import { z } from 'zod/v4';
// Notification types
export const NotificationTypeSchema = z.enum([
    'work_claimed', // Someone claimed work from your backlog
    'work_assigned', // Work was assigned to you
    'work_reassigned', // Work was reassigned from you
    'mention', // You were mentioned in a comment
]);
// Entity types that can be linked to notifications
export const NotificationEntityTypeSchema = z.enum(['assignment', 'task', 'order', 'case']);
// Notification schema
export const NotificationSchema = z.object({
    id: z.string().uuid(),
    userId: z.string(), // Recipient user ID
    type: NotificationTypeSchema,
    title: z.string(),
    body: z.string(),
    entityType: NotificationEntityTypeSchema.optional(),
    entityId: z.string().optional(),
    actorId: z.string().optional(), // User who triggered the notification
    actorName: z.string().optional(), // Display name of actor
    read: z.boolean().default(false),
    readAt: z.string().datetime().optional(),
    createdAt: z.string().datetime(),
});
// Schema for creating a notification
export const CreateNotificationSchema = NotificationSchema.omit({
    id: true,
    read: true,
    readAt: true,
    createdAt: true,
});
// Schema for updating notification (mark as read)
export const UpdateNotificationSchema = z.object({
    read: z.boolean().optional(),
});
